import Card from '@/components/elements/Card';
import Container from '@/components/global/Container';
import { Icon } from '@/components/global/Icons';
import { IComponentBlocksMap } from '@/graphql/__generated__/global/types';
import mapboxgl, { LngLat } from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import dynamic from 'next/dynamic';
import locations from 'public/locations.json';

const [Mapbox, Marker, NavigationControl] = [
    dynamic(() => import('react-map-gl').then((module) => module.Map), {
        ssr: false,
    }),
    dynamic(() => import('react-map-gl').then((module) => module.Marker), {
        ssr: false,
    }),
    dynamic(() => import('react-map-gl').then((module) => module.NavigationControl), {
        ssr: false,
    }),
];

const mapboxStyle = 'mapbox://styles/voyage-jucy/clj3q4zl200sr01od043l97b9';

const Map = ({ customMarkers, branchLocations }: IComponentBlocksMap) => {
    const branches = branchLocations?.map((branch) => {
        const branchLocation = branch?.branchLocations?.replace('_', ' ');
        const result = locations.filter((location) => location.name === branchLocation);
        return result.length > 0 ? result[0].geoLocation : null;
    });

    const allMarkers = [
        // Map together customer markers & fetch branch locations from name
        ...(customMarkers?.map((m) => m.location) ?? []),
        // Map customer markers to location in Strapi
        ...(branches ?? []),
    ].filter((marker) => {
        if (!marker?.lat || !marker?.lng || isNaN(marker?.lat) || isNaN(marker?.lng)) {
            console.warn(`Marker has invalid coordinates`, marker);
            return false;
        }
        return true;
    }) as LngLat[]; // Filter out any undefined values

    const mapBounds = new mapboxgl.LngLatBounds();
    allMarkers.forEach((marker) => {
        mapBounds.extend(marker);
    });

    return (
        <Container>
            <Card>
                <Mapbox
                    style={{ width: '100%', height: '45rem' }}
                    mapStyle={mapboxStyle}
                    mapboxAccessToken={process.env.NEXT_PUBLIC_MAPBOX_TOKEN}
                    attributionControl={false}
                    cooperativeGestures={true}
                    keyboard={true}
                    trackResize={true}
                    initialViewState={allMarkers.length > 0 ? { bounds: mapBounds, fitBoundsOptions: { padding: 64, maxZoom: 12 } } : { zoom: 6 }}
                    boxZoom={true}
                    doubleClickZoom={true}
                    minZoom={2.5}
                >
                    <NavigationControl />
                    {allMarkers.map((marker, key) => {
                        return (
                            <Marker key={key} longitude={marker.lng} latitude={marker.lat} anchor="bottom" color="#112745">
                                <Icon id="map-marker" className="w-12 h-12" />
                            </Marker>
                        );
                    })}
                </Mapbox>
            </Card>
        </Container>
    );
};

export default Map;
